<template>
    <div class="p-grid">
        <Toast />
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('MemberStatistic.list.Search') }}</strong>
                </h4>
                <br />
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="nameuser">{{ $t('MemberStatistic.list.Usertype') }}</label>
                        <Dropdown v-model="user_type" :options="UserTypedropdown" optionLabel="name" optionValue="code" :placeholder="$t('MemberStatistic.list.Select')" name="first_category" id="first_category" />
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="pass">{{ $t('MemberStatistic.list.StartDate') }}</label>
                        <Calendar :showIcon="true" :maxDate="maxDateValue" :showButtonBar="false" v-model="from_date" dateFormat="yy.mm.dd" placeholder="YYYY-MM-DD" :manualInput="false" :max-date="new Date()"> </Calendar>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="pass">{{ $t('MemberStatistic.list.EndDate') }}</label>
                        <Calendar :showIcon="true" :maxDate="maxDateValue" :showButtonBar="false" v-model="to_date" dateFormat="yy.mm.dd" placeholder="YYYY-MM-DD" :manualInput="false" :max-date="new Date()"> </Calendar>
                    </div>
                </div>

                <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mt-6 p-flex-column p-flex-lg-row">
                    <div class="p-mb-4 p-mb-lg-0">
                        <!-- <Button :label="$t('button.today')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="today"></Button>
                        <Button :label="$t('button.lastWeek')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastweek"></Button>
                        <Button :label="$t('button.lastMonth')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastmonth"></Button>
                        <Button :label="$t('button.last6Months')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastsixmonth"></Button>
                         <Button :label="$t('button.lastYear')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastyear"></Button>  -->
                    </div>
                    <div class="p-mb-4 p-mb-lg-0">
                        <Button :label="$t('button.search')" icon="pi pi-search" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="searchproduct"></Button>
                        <Button :label="$t('button.reset')" icon="pi pi-replay" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="resetUser"></Button>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-col-12">
            <div class="card">
                <div class="p-d-flex p-jc-between p-mb-2">
                    <div>
                        <h5>{{ $t('MemberStatistic.list.StatisticListing') }}</h5>
                    </div>
                    <!-- <div>
                        <router-link :to="'/AddProductCategory'">
                            <Button label="Primary" class="p-mr-2 p-mb-2"><i class="pi pi-download p-mr-2"></i>{{ $t('Add New') }}</Button>
                        </router-link>
                        <router-link :to="''">
                            <Button label="Primary" class="p-mr-2 p-mb-2"><i class="pi pi-download p-mr-2"></i>{{ $t('Upload Excel') }}</Button>
                        </router-link>
                        <Button label="Primary" class="p-mr-2 p-mb-2" @click="exceldownload"><i class="pi pi-download p-mr-2"></i>{{ $t('button.downloadExcel') }}</Button>
                    </div> -->
                </div>
                <div class="p-mb-4 p-mb-lg-0 page">
                    <label for="order"
                        >{{ $t('MemberStatistic.list.Record') }} {{ pagination.total_records }}
                        <Dropdown class="p-ml-2" id="order" v-model="pagination.pagination_limit" :options="pagination_limit_options" optionLabel="label" optionValue="value" placeholder="10개씩 보기" />
                    </label>

                    <div style="display: flex; float: right">
                        <Dropdown v-model="sortByValue" :options="sort_by" optionValue="value" optionLabel="label" placeholder="정렬 기준" @change="sortingOrdering" />
                        &nbsp;&nbsp;&nbsp;
                        <Dropdown v-model="sortOrderValue" :options="sort_order" optionValue="value" optionLabel="label" placeholder="정렬 순서" @change="sortingOrdering" />
                    </div>
                </div>
                <br />
                <DataTable :paginator="false" :value="results" class="p-datatable-gridlines" :rows="10" dataKey="id" :loading="loading" :rowHover="true" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                    <!-- v-model:selection="selected" -->
                    <ConfirmDialog group="dialog" />

                    <template #empty>문의를 찾을 수 없습니다</template>
                    <template #loading>어드민 정보 로딩중..</template>

                    <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                    <Column field="slNO" :header="$t('MemberStatistic.list.No')" style="min-width: 5rem">
                        <template #body="{ index }">
                            <span class="p-column-title">#</span>
                            <!-- {{ this.totalrecords - index - (pagination.current_page - 1) * pagination.pagination_limit }} -->
                            {{ pagination.current_page * pagination.pagination_limit - pagination.pagination_limit + (index + 1) }}
                        </template>
                    </Column>
                    <Column field="name" :header="$t('MemberStatistic.list.Name')" style="min-width: 10rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Name</span>
                            {{ data.name }}
                        </template>
                    </Column>
                    <Column field="name" :header="$t('MemberStatistic.list.Usertype')" style="min-width: 10rem">
                        <template #body="{ data }">
                            <span class="p-column-title">User Type</span>
                            {{ data.user_type == 'job_seeker' ? '구직자' : '구인자' }}
                        </template>
                    </Column>
                    <Column :header="$t('MemberStatistic.list.Email')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Email</span>
                            {{ data.email }}
                        </template>
                    </Column>
                    <Column :header="$t('MemberStatistic.list.Avarage Rating')" style="min-width: 10rem" field="avg_rating">
                        <template #body="{ data }">
                            <span class="p-column-title">Avarage Rating</span>
                            {{ data.avg_rating === 0 ? '5' : data.avg_rating }}
                        </template>
                    </Column>
                    <Column :header="$t('MemberStatistic.list.rating')" style="min-width: 12rem" field="no_of_ratings" >
                        <template #body="{ data }">
                            <span class="p-column-title">No. of rating</span>
                            {{ data.no_of_ratings }}
                        </template>
                    </Column>
                    <Column :header="$t('MemberStatistic.list.Ranking')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Ranking</span>
                            {{ data.final_ranking }}
                        </template>
                    </Column>
                    <!--  -->
                </DataTable>
                <div class="p-paginator p-component p-paginator-bottom">
                    <button @click="paginate(1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-first p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-double-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button @click="paginate(pagination.current_page - 1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-next p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <span class="p-paginator-pages">
                        <button
                            v-for="(page, index) in get_paginator_page(pagination.total_pages, pagination.current_page)"
                            :key="index"
                            @click="paginate(page)"
                            class="p-paginator-page p-paginator-element p-link"
                            :class="{ 'p-highlight': page === pagination.current_page }"
                            type="button"
                        >
                            {{ page }}<span class="p-ink"></span>
                        </button>
                    </span>
                    <button
                        @click="paginate(pagination.current_page + 1)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        class="p-paginator-next p-paginator-element p-link"
                        type="button"
                        :disabled="pagination.current_page === pagination.total_pages"
                    >
                        <span class="p-paginator-icon pi pi-angle-right"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button
                        @click="paginate(pagination.total_pages)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        :disabled="pagination.current_page === pagination.total_pages"
                        class="p-paginator-last p-paginator-element p-link"
                        type="button"
                    >
                        <span class="p-paginator-icon pi pi-angle-double-right"></span>
                        <span class="p-ink"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { useRoute } from 'vue-router';
// import validateUsersearch from '../../validations/user/validateUserSearch';
// import { FilterMatchMode, FilterOperator } from 'primevue/api';
import MemberService from '../../service/API/MemberService';
import axios from 'axios';
import utils from '@/service/utils';
// import ProductService from '../service/ProductService';
// import axios from 'axios';
export default {
    data() {
        return {
            selected: [],
            selectedItemss: '',
            start_date: '',
            end_date: '',
            render: true,
            display: false,
            position: 'center',
            visibleLeft: false,
            visibleRight: false,
            visibleTop: false,
            visibleBottom: false,
            visibleFull: false,
            dropdownValue: null,
            dropdownValues: '',
            SeconddropdownValues: '',
            SeconddropdownValue: null,
            customer1: null,
            loading: true,
            idFrozen: false,
            products: null,
            expandedRows: [],
            user: null,
            totalrecords: '',
            UserTypedropdowns: '',
            UserTypedropdown: [
                { name: '구직자', code: 'job_seeker' },
                { name: '구인자', code: 'job_recruiter' },
            ],
            statusdropdowns: '',
            statusdropdown: [
                { name: 'Active', code: 'active' },
                { name: 'Inactive', code: 'inactive' },
            ],
            statuses: ['unqualified', 'qualified', 'new', 'negotiation', 'renewal', 'proposal'],
            genders: [
                { name: 'Statistical', code: 'Statistical' },
                { name: 'Coupon', code: 'Coupon' },
                { name: 'Survey reminder', code: 'Survey reminder' },
                { name: 'Manual', code: 'Manual' },
            ],
            pets: [
                { name: 'Yes', code: 'Yes' },
                { name: 'No', code: 'No' },
            ],
            marital_statuss: [
                { name: 'married', code: 'married' },
                { name: 'unmarried', code: 'unmarried' },
            ],
            age_groups: [
                { name: '25~35', code: '25 ~ 35' },
                { name: '35~45', code: '35 ~ 45' },
                { name: '45~55', code: '45 ~ 55' },
                { name: '55~65', code: '55 ~ 65' },
            ],
            dropdownItem: null,
            error: {},
            //params for list
            Ntitle: '',
            Ntype: '',
            // start_date: '',
            // end_date: '',
            id: '',
            notification_type: '',
            productCategoryStatus: '',
            pagination_limit_options: [
                { label: '10개씩 보기', value: 10 },
                { label: '20개씩 보기', value: 20 },
                { label: '50개씩 보기', value: 50 },
                { label: '100개씩 보기', value: 100 },
            ],
            pagination: {
                current_page: 1,
                pagination_limit: 10,
                total_pages: 0,
                total_records: 0,
            },
            user_type: '',
            from_date: '',
            to_date: '',
            results: [],
            sort_order: [
                { value: 'asc', label: '오름차순' },
                { value: 'desc', label: '내림차순' },
            ],
            sortOrderValue: '',
            sort_by: [
                // { value: 'id', label: 'ID' },
                { value: 'average_rating', label: '평균 평점' },
                { value: 'number_of_ratings', label: '평가수' },
                { value: 'membership_type', label: '회원 유형' },
            ],
            sortByValue: '',
        };
    },
    customerService: null,
    productService: null,
    created() {
        this.memberService = new MemberService();
    },
    mounted() {
        this.getMSlist();
    },
    watch: {
        'pagination.pagination_limit'(val) {
            this.getMSlist({ limit: val, page: 1 });
        },
    },
    methods: {
        getMSlist() {
            const StatisticsParams = {
                page: 1,
                limit: this.pagination.pagination_limit,
                user_type: this.user_type,
                from_date: this.from_date,
                to_date: this.to_date,
            };
            this.loading = true;
            this.memberService
                .GetStatisticList(StatisticsParams)
                .then((res) => {
                    this.results = res.data.result;
                    this.totalrecords = res.data.total_records;
                    this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading = false;
                    console.log(this.totalrecords);
                })
                .catch((err) => console.log(err));
        },
        setPagination(current_page, total_pages, total_records) {
            this.pagination.current_page = current_page;
            this.pagination.total_pages = total_pages;
            this.pagination.total_records = total_records;
        },
        get_paginator_page(total, active) {
            return utils.paginate(total, active);
        },

        paginate(page) {
            this.loading = true;
            this.memberService
                .GetStatisticList({
                    page: page,
                    limit: this.pagination.pagination_limit,
                    user_type: this.user_type,
                    from_date: this.startDate,
                    to_date: this.endDate,
                    sorting_field: this.sortByValue,
                    sorting_field_order: this.sortOrderValue,
                })
                .then((res) => {
                    this.results = res.data.result;
                    this.pagination.current_page = page;
                    this.loading = false;
                    console.log(res.data);
                })
                .catch((err) => console.log(err));
        },
        // selects() {
        //     let xyz = [];
        //     let data = this.selected;
        //     for (var a = 0; a < data.length; a++) {
        //         xyz.push(data[a].id);
        //     }
        //     this.selectedItemss = xyz.toString();
        //     if (this.calendarValue !== '') {
        //         this.calendarValue = this.calendarValue.toISOString().slice(0, 10);
        //     }
        //     if (this.calendarValue1 !== '') {
        //         this.calendarValue1 = this.calendarValue1.toISOString().slice(0, 10) + 1;
        //     }
        // },
        sortingOrdering() {
            // console.log('sortingOrdering');
            this.loading = true;

            let SortParams = {
                limit: this.pagination.pagination_limit,
                page: 1,
                user_type: this.user_type,
                from_date: this.startDate,
                to_date: this.endDate,
                sorting_field: this.sortByValue,
                sorting_field_order: this.sortOrderValue,
            };
            // this.loading = true;
            this.memberService
                .GetStatisticList(SortParams)
                .then((res) => {
                    this.results = res.data.result;
                    this.totalrecords = res.data.total_records;
                    this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading = false;
                    console.log(res);
                })
                .catch(() => {
                    this.results = [];
                    this.loading = false;
                });
        },
        resetUser() {
            this.from_date = '';
            this.to_date = '';
            this.user_type = '';
            this.sortByValue = '';
            this.sortOrderValue = '';
            // this.pagination.pagination_limit = '';
            this.getMSlist();
        },
        addDay(val) {
            const date = new Date(val);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (val = yyyy + '-' + mm + '-' + dd);
        },

        searchproduct() {
            if (this.from_date == '' && this.to_date == '' && this.user_type == '') {
                // console.log(this.productCategoryStatus);
                this.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '1개 이상의 검색 값을 입력하세요.', life: 3000 });
            } else if (this.from_date !== '' && this.to_date == '') {
                // console.log(this.productCategoryStatus);
                this.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '일자 기간을 설정해 주세요.', life: 3000 });
            } else if (this.from_date == '' && this.to_date !== '') {
                // console.log(this.productCategoryStatus);
                this.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '일자 기간을 설정해 주세요.', life: 3000 });
            } else if (this.from_date !== '' || this.to_date !== '' || this.user_type !== '') {
                if (this.from_date != '') {
                    this.startDate = this.addDay(this.from_date);
                } else {
                    this.startDate = '';
                }
                if (this.to_date != '') {
                    this.endDate = this.addDay(this.to_date);
                } else {
                    this.endDate = '';
                }
                let searchParams = {
                    limit: this.pagination.pagination_limit,
                    page: 1,
                    user_type: this.user_type,
                    from_date: this.startDate,
                    to_date: this.endDate,
                    sorting_field: this.sortByValue,
                    sorting_field_order: this.sortOrderValue,
                };
                this.loading = true;
                this.memberService
                    .GetStatisticList(searchParams)
                    .then((res) => {
                        this.results = res.data.result;
                        this.totalrecords = res.data.total_records;
                        this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                        this.loading = false;
                        console.log(res);
                    })
                    .catch(() => {
                        this.results = [];
                        this.loading = false;
                    });
                // this.getMSlist();
            }
        },
        exceldownload() {
            this.productCategoryService.getExcel(this.first_category, this.second_category, this.third_category, this.productCategoryStatus?.code).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Productcategorylist.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        today() {
            const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
            this.start_date = utc;
            this.end_date = utc;
            this.getlist();
            console.log(this.start_date);
        },
        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        getParams(NotificationType) {
            localStorage.setItem('NotificationType', NotificationType);
            console.log(NotificationType);
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },

        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '.' + mm + '.' + dd);
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }

            return total;
        },

        confirm(id) {
            var self = this;
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'delete', url: `/product-category/${id}` }).then(function () {});
                    self.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                    self.productCategoryService.getProductCategoryList(self.first_category, self.second_category, self.third_category, self.productCategoryStatus).then((data) => {
                        console.log(data);
                        this.customer1 = data;
                        this.loading = false;
                        this.customer1.forEach((customer) => (customer.createdDate = new Date(customer.createdDate)));
                    });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}

.p-fluid {
    .p-button {
        width: auto;
    }
}

.p-button {
    background: white;
    border: 1px solid blue;
    color: black;
}

// .p-button1 {
//     background-color: black;
//     color: white;
//     border-color: black;
// }
button.p-button.p-component.p-button2.p-component.p-button.p-button-sm.p-mr-2.p-mb-2 {
    border: 1px solid blue;
    color: black;
    background: white;
}
</style>
